import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import {
  STATUS_CANCELLED,
  DISPLAY_STATUS,
  APPROVAL_REQUEST_CONFIG,
  STATUS_STYLE_MAP,
  PROCESS_REQUEST_HAND_SHIPMENT_FIELD,
} from '../../../constants/ApprovalRequestConstants'
import { Error, Loader } from '../../common'
import { fetchExceptionTestingApprovalRequestHistory } from '../../../actions/approvalRequestHistory'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
} from '../../../selectors/approvalRequests'
import {
  getExceptionTestingRequestHistory,
  getExceptionTestingRequestHistoryStatusProps,
} from '../../../selectors/requestHistory'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const arType = selectApprovalRequestType(state)
  const { fetching, error } = getExceptionTestingRequestHistoryStatusProps(state)
  const arId = selectedApprovalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
  return {
    approvalHistory: getExceptionTestingRequestHistory(state, arId),
    arId,
    fetching,
    error,
    panelIsOpen,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchExceptionTestingApprovalRequestHistory }, dispatch)

const StatusComments = ({ comments }) => {
  if (comments) {
    return <div style={{ fontStyle: 'italic' }}>{`"${comments}"`}</div>
  }
  return null
}

const ApprovalRequestHistoryRow = connect(mapStateToProps)(({ status, key, first }) => {
  const { etsApprovalStatus, course, quantity, reviewedBy, comments, updateTimestamp } = status
  return (
    <tr key={key}>
      <td style={first ? { borderTopWidth: 0 } : {}}>
        <div style={STATUS_STYLE_MAP[etsApprovalStatus]}>{DISPLAY_STATUS[etsApprovalStatus]}</div>
        {status[PROCESS_REQUEST_HAND_SHIPMENT_FIELD] && (
          <div style={{ fontStyle: 'italic' }}>Handshipped</div>
        )}
        {etsApprovalStatus !== STATUS_CANCELLED ? (
          <>
            {course && <div>{course}</div>}
            {quantity && <div>Quantity: {quantity}</div>}
            {reviewedBy && <div>Processed By: {reviewedBy}</div>}
            <StatusComments comments={comments} />
          </>
        ) : null}
      </td>
      <td style={first ? { borderTopWidth: 0, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' }}>
        {formatDate(updateTimestamp, DATETIME_FORMATS.longMonthDayYear)}
      </td>
    </tr>
  )
})

const ApprovalRequestHistoryTable = connect(mapStateToProps)(({ approvalHistory = [] }) => {
  return (
    <table
      className="table"
      summary="Status of Exception Testing approval requests are listed by status date in descending order."
    >
      <caption className="sr-only">A view of Exception Testing approval request history</caption>
      <thead>
        <tr>
          <th scope="col">Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {approvalHistory.map((row, index) => (
          <ApprovalRequestHistoryRow status={row} key={`${Math.random()}`} first={index === 0} />
        ))}
      </tbody>
    </table>
  )
})

class RequestHistory extends Component {
  componentDidMount() {
    const { arId, fetchExceptionTestingApprovalRequestHistory } = this.props

    fetchExceptionTestingApprovalRequestHistory(arId)
  }

  componentDidUpdate(prevProps) {
    const { arId, panelIsOpen, fetchExceptionTestingApprovalRequestHistory } = this.props

    if (panelIsOpen && prevProps.arId !== arId) {
      fetchExceptionTestingApprovalRequestHistory(arId)
    }
  }

  render() {
    const { approvalHistory = [], fetching, error } = this.props
    let output = null

    if (fetching) {
      output = <Loader />
    } else if (error) {
      output = <Error title="Error" message={error} />
    } else if (approvalHistory.length) {
      output = <ApprovalRequestHistoryTable />
    } else {
      output = <>No request history available</>
    }

    return (
      <div className="row" style={{ paddingBottom: '1.5em' }}>
        <div className="col-xs-12">{output}</div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestHistory)
